module.exports = __webpack_public_path__ + "static/media/beaconHomeLg.00960a22.jpeg";